<template>
  <div class="simulateur-vue simulateur-mensualite-vue">
      <div class="input-data-container">
        <div class="row" >
          <div class="columns medium-12 small-12 " > 
            <div class="fields-container">
              <div class="field-group-title">Votre prêt</div>
              <div class="form-input">
                <label>
                  <cleave v-model="montant" :options="cleaveOptionsDecimal"></cleave>
                  <span class="placeholder">Montant du prêt</span>
                  <span class="unit">€</span>
                </label>
              </div>
    
              <div class="form-input result">
                <label>
                  <select v-model="duree"> 
                    <option :value="taux.duree" v-for="taux in tauxSimulateurs">Sur {{taux.duree}} ans (Taux annuel à {{taux.taux.toFixed(2)}}%)</option>
                  </select>
                  <span class="placeholder">Durée et taux de votre prêt</span>
                </label>
              </div>
              
              
              <!-- <div class="submit-block ">
                <a @click="calculate()" class="submit cp-button green rounded">Calculer</a>
              </div> -->
            </div>
          </div>
        </div>
      </div>

   
      <div class="result-container">
        <div class="result-title">Résultats de votre simulation</div>
         <div v-if="error" class="flash-error">{{error}}</div>
        <div class="row">
          <div class="columns medium-12 small-12">
            <div class="fields-container"> 
              <div class="field-group-title">Vos mensualités</div>
              <div class="form-input result">
                <label>
                  <cleave disabled v-model="mensualite" :options="cleaveOptionsDecimal"></cleave>
                  <span class="placeholder">Vos mensualités</span>
                  <span class="unit">€/mois</span>
                </label>
              </div>
              <div class="form-input result">
                <label>
                  <cleave disabled v-model="coutEmprunt" :options="cleaveOptionsDecimal"></cleave>
                  <span class="placeholder">Coût total de votre emprunt</span>
                  <span class="unit">€</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
   
  </div>
</template>

<script>
import common from './common.js'
import Vue from 'vue'

Vue.filter('formatNumber', function(number) {
  if (number) {
    return number.toFixed(2)
  }
})

export default {
  mounted () {
    this.taux = window.taux
    this.tauxSimulateurs = window.tauxSimulateurs
    let tmpDuree = this.tauxSimulateurs[0]
    if(tmpDuree) {
        this.duree = tmpDuree.duree
    }
  },
  computed: {
    tauxAnnuel () {
       let item = this.tauxSimulateurs.find((item) => {
          if(item.duree === this.duree) {
            return item
          }
      })
      if(item) {
        return item.taux
      }
     
    },
    tauxAnnuelSousUn () {
      return this.tauxAnnuel / 100
    },
    tauxMensuelSousUn () {
      return this.tauxAnnuelSousUn / 12
    },
    dureeCreditEnMois () {
      return this.duree * 12
    },
    mensualiteBrute () {
      return  this.montant / (this.duree * 12)
    },
    mensualite () {
      return (this.montant * this.tauxMensuelSousUn ) / (1 -  Math.pow( 1 + this.tauxMensuelSousUn  , -this.dureeCreditEnMois))
    },
    coutEmprunt () {
      return this.mensualite * this.dureeCreditEnMois
    }
    
  },
  data () {
    return {
      tauxSimulateurs: [],
      taux: {},
      duree: null,
      montant: null,
      cleaveOptionsDecimal: {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: ' '
      },
      cleaveOptionsInteger: {
          numeral: true,
          numeralDecimalMark: '',
          delimiter: ' '
      },
        
    }
  },
  methods: {
    calculate () {
     
    }

  }
}
</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/js/vue/components/SimulateurMensualites.vue